/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-table-of-contents': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2.5 3.75h11.25V5H2.5V3.75zm0 3.75h11.25v1.25H2.5V7.5zm0 3.75h11.25v1.25H2.5v-1.25zm0 3.75h11.25v1.25H2.5V15zM16.25 3.75h1.25V5h-1.25V3.75zm0 3.75h1.25v1.25h-1.25V7.5zm0 3.75h1.25v1.25h-1.25v-1.25zm0 3.75h1.25v1.25h-1.25V15z"/>'
  }
})
